import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import InstallButton from "@/components/InstallButton";
import { LogOut, LayoutDashboard, Search, Stethoscope } from "lucide-react";

export default function Header() {
  const { lang, setLang, t, role, logout } = useApp();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-white/85 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 h-16 flex items-center justify-between gap-3">
        <Logo />
        <div className="flex items-center gap-2 sm:gap-3">
          <Link to="/buscar" data-testid="nav-search-link"
                className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-slate-700 hover:text-blue-700 transition-colors px-2">
            <Search size={16} /> {t.nav.search}
          </Link>
          {role === "patient" && (
            <Link to="/paciente/panel" data-testid="nav-patient-space"
                  className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-blue-700 hover:text-blue-800 transition-colors px-2">
              {t.nav.patientSpace}
            </Link>
          )}
          {!role && (
            <Link to="/paciente/login" data-testid="nav-patient-login"
                  className="hidden md:inline-flex items-center gap-1.5 text-sm font-medium text-slate-700 hover:text-blue-700 transition-colors px-2">
              {t.nav.patientLogin}
            </Link>
          )}
          {role === "doctor" ? (
            <Button data-testid="nav-dashboard-btn" size="sm" variant="ghost"
                    onClick={() => nav("/doctor/panel")}
                    className="hidden sm:inline-flex text-blue-700 hover:bg-blue-50">
              <LayoutDashboard size={16} className="mr-1.5" />{t.nav.dashboard}
            </Button>
          ) : (
            <Link to="/doctor/login" data-testid="nav-doctor-login-link"
                  className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-slate-700 hover:text-blue-700 transition-colors px-2">
              <Stethoscope size={16} />{t.nav.doctorLogin}
            </Link>
          )}
          {(role === "doctor" || role === "admin" || role === "patient") && (
            <Button data-testid="nav-logout-btn" size="sm" variant="ghost"
                    onClick={() => { logout(); nav("/"); }}
                    className="hidden sm:inline-flex text-slate-600">
              <LogOut size={16} className="mr-1.5" />{t.nav.logout}
            </Button>
          )}
          <InstallButton />
          <Select value={lang} onValueChange={setLang}>
            <SelectTrigger data-testid="lang-switcher"
                           className="w-[76px] sm:w-[92px] h-9 border-slate-200 bg-white text-sm font-medium">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem data-testid="lang-es" value="es">🇪🇸 ES</SelectItem>
              <SelectItem data-testid="lang-fr" value="fr">🇫🇷 FR</SelectItem>
              <SelectItem data-testid="lang-en" value="en">🇬🇧 EN</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </header>
  );
}
